<template>
  <div class="list lichtuan-maincontent">
    <!-- header-title -->
    <div class="header-title flex-row flex__between margin-bottom-10">
      <!-- <div class="leftSection flex-row flex__left"> -->
      <div class="theTitle theTitle__lv5 flex-row flex__center">STT</div>
      <div class="theTitle theTitle__lv1 flex-row flex__left">Tiêu đề</div>
      <!-- </div>
      <div class="rightSection flex-row flex__right"> -->
      <div class="theTitle theTitle__lv3 flex-row flex__left">Người duyệt</div>
      <div class="theTitle theTitle__lv4 flex-row flex__left">Trạng thái</div>
      <div
        class="theTitle theTitle__lv4 flex-row flex__left"
        @click="sortByColumn('startTime')"
      >
        Ngày bắt đầu
        <sort-caret
          :order="currentCreateTimeOrder"
          :sort="currentSortBy"
          :field="'startTime'"
        />
      </div>
      <div
        class="theTitle theTitle__lv4 flex-row flex__left"
        @click="sortByColumn('createTime')"
      >
        Ngày tạo
        <sort-caret
          :order="currentCreateTimeOrder"
          :sort="currentSortBy"
          :field="'createTime'"
        />
      </div>
      <!-- </div> -->
    </div>
    <!-- list-docs -->
    <VuePerfectScrollbar
      class="scroll-area"
      :settings="perfectScrollbarSetting"
      infinite-wrapper
    >
      <div class="list-docs" style="margin-right: 0px">
        <div
          class="item flex-row flex__between clickable"
          v-for="(item, $itemIndex) in this.data"
          v-bind:key="$itemIndex"
          @click="viewDetail(item)"
        >
          <!-- <div class="leftSection flex-row flex__left "> -->
          <div class="theTitle__lv5">
            <div class="flex-row flex__center">
              <div class="section-check flex-row flex__center">
                {{ $itemIndex + 1 }}
              </div>
              <img
                class="icon-small"
                src="../../../assets/img/symbol/doc.svg"
                alt
              />
            </div>
          </div>
          <div class="theTitle__lv1">
            <div class="flex-col flex__left">
              <a
                class="custom-link-detail"
                :href="convertLinkToDetail(item)"
                @click="stopProcess"
              >
                <span class="tt_1 clickable">{{ item.meetingTitle }}</span>
              </a>
              <span>{{ item.meetingPlace }}</span>
            </div>
          </div>
          <!-- </div>
          <div class="rightSection flex-row flex__right"> -->
          <div class="theTitle__lv3 flex-row flex__left font-size__small">
            <div class="flex-row flex__left">
              {{ item.approveUserName || "Chưa có người duyệt" }}
            </div>
          </div>
          <!--            region Tình trạng phê duyệt-->
          <div
            class="theTitle__lv4 flex-row flex__left font-size__small"
            style="margin-right: -13px"
          >
            <div class="flex-row flex__center">
              <el-tag
                v-if="item.approveStatus === 'Tạm phê duyệt'"
                size="mini"
                :class="['priority', 'lv3']"
              >
                {{ item.approveStatus }}
              </el-tag>
            </div>
            <div class="flex-row flex__center">
              <el-tag
                v-if="item.approveStatus === 'Chưa phê duyệt'"
                size="mini"
                :class="['priority', 'lv2']"
              >
                {{ item.approveStatus }}
              </el-tag>
            </div>
            <div class="flex-row flex__center">
              <el-tag
                v-if="item.approveStatus === 'Đã ban hành'"
                size="mini"
                :class="['priority', 'lv4']"
              >
                {{ item.approveStatus }}
              </el-tag>
            </div>
            <div class="flex-row flex__center">
              <el-tag
                v-if="item.approveStatus === 'Hủy yêu cầu'"
                size="mini"
                :class="['priority', 'lv1']"
              >
                {{ item.approveStatus }}
              </el-tag>
            </div>
            <div class="flex-row flex__center">
              <el-tag
                v-if="item.approveStatus === 'Không phê duyệt'"
                size="mini"
                :class="['priority', 'lv1']"
              >
                {{ item.approveStatus }}
              </el-tag>
            </div>
          </div>
          <!--            test-->

          <!--region Ngày bắt đầu-->
          <div class="theTitle__lv4 flex-row flex__left font-size__small">
            <div class="flex-row flex__left">
              <span>{{
                item.startTime | dateFormatter({ nullValue: "-" })
              }}</span
              >&nbsp;&nbsp;
            </div>
          </div>
          <!--endregion-->

          <!--region Ngày tạo-->
          <div class="theTitle__lv4 flex-row flex__left font-size__small">
            <div class="flex-row flex__left">
              <span>{{
                item.createTime | dateFormatter({ nullValue: "-" })
              }}</span
              >&nbsp;&nbsp;
              <div
                :class="[
                  'theDueDate',
                  item.status === 'DANGXULY'
                    ? 'lv2'
                    : item.status === 'HOANTHANH'
                    ? 'lv3'
                    : item.status === 'HUY'
                    ? 'lv1'
                    : '',
                ]"
              ></div>
            </div>
          </div>
          <!--endregion-->
        </div>
        <!-- </div> -->

        <infinite-loading
          ref="infiniteLoading"
          spinner="spiral"
          @infinite="infiniteHandler"
        >
          <div slot="no-more"></div>
          <div slot="no-results"></div>
        </infinite-loading>
        <div class="flex-row flex__center" v-if="this.data.length === 0">
          Không có dữ liệu
        </div>
      </div>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import dateFormatter from "../../../filters/dateFormatter";
import SortCaret from "../../doc-out/SortCaret";
import qs from "qs";

export default {
  name: "LichTuan_MainContent",
  props: ["data", "filterStatus"],
  components: {
    VuePerfectScrollbar,
    SortCaret,
  },
  filters: { dateFormatter },
  methods: {
    convertLinkToDetail(item) {
      return `${window.location.origin}/#/app/${this.$store.getters.userDeptRoleId}/administrasion/regiscalendarweek/detail/${item.caseMasterId}?filterStatus=${this.filterStatus}`;
    },

    stopProcess(e) {
      e.preventDefault();
    },

    formatQuery(params) {
      return qs.stringify(params, {
        arrayFormat: "repeat",
      });
    },

    sortByColumn(columName) {
      this.currentCreateTimeOrder =
        this.currentCreateTimeOrder === "desc" ? "asc" : "desc";
      this.currentSortBy = columName;
      this.$emit("sortByColumn", {
        sortBy: this.currentSortBy,
        sortOrder: this.currentCreateTimeOrder,
      });
    },

    viewDetail(item) {
      this.$emit("viewDetail", {
        caseMasterId: item.caseMasterId,
      });
    },
    infiniteHandler($state) {
      this.$emit("infiniteHandler", $state);
    },
  },
  data() {
    return {
      currentSortBy: "startTime",
      currentCreateTimeOrder: "desc",
    };
  },
  watch: {
    data(newValue) {
      if (newValue !== this.data) {
        this.data = newValue;
      }
    },
  },
};
</script>

<style scoped>
.list .header-title {
  margin: 0 5px 0 4px;
}

/* Start responsive 19/05 */
.lichtuan-maincontent .header-title .theTitle__lv1 {
  width: 30% !important;
}
.lichtuan-maincontent .theTitle__lv1 {
  width: 20% !important;
}
.lichtuan-maincontent .header-title .theTitle__lv3 {
  width: 19.5% !important;
}
.lichtuan-maincontent .theTitle__lv3 {
  width: 19% !important;
}
.lichtuan-maincontent .theTitle__lv4 {
  width: 17% !important;
}
.lichtuan-maincontent .theTitle__lv5 {
  width: 8% !important;
}
/* End responsive 19/05 */
</style>



// WEBPACK FOOTER //
// src/views/adminstration/lichtuan/LichTuan_MainContent.vue